import request from '@/utils/request';
import { iStatisticConfig, iStatisticDetail, iResult } from '@/interface/result';
import { AxiosPromise } from 'axios';
/**
 * 客服工具-设备巡检-设备列表
 * @param params
 */
export const getMachinesList = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/customer/machines',
    params,
  });
/**
 * 客服工具-设备巡检-设备列表  导出
 * @param params
 */
export const getMachinesExport = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/customer/machines',
    params,
    responseType: 'blob',
  });
/* 客服工具-设备巡检-设备批量操作
 */
export const getMachinesOperation = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/customer/machines/operation',
    method: 'put',
    data,
  });
/*客服工具-设备巡检-直连文件
 */
export const getMachinesBats = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/customer/machines/bats',
    params,
    responseType: 'blob', // 表明返回服务器返回的数据类型
  });
/*客服工具-设备巡检-商户下拉列表
 */
export const getMchSelects = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/customer/mch/selects',
    params,
  });
